module.exports = __webpack_public_path__ + "static/Yuli-Rios-661cdb1cb86740eb4e9f4988a5cfb1eb.png";